module.exports = __webpack_public_path__ + "img/103-62-flat.ed1c8a61.jpg";